import React, { useState } from 'react'
// import { Link } from 'react-router-dom'
import GetAQuote from '../modals/TechnologyWorkModal'
import { handleWhatsAppClick } from '../whatsappClickTrack';

function Footer() {
    const [openModal, setOpenModal] = useState(false);
    const toggle = () => {
        setOpenModal(!openModal);
    }
    return (
        <footer className="footer-a">
            <GetAQuote openModal={openModal} toggle={toggle} />
            <div className="footer-fist-row pt40">
                <div className="container">
                    <div className="row footer-deg2">
                        <div className="col-5s">
                            <div className="footer-ree-c">
                                <div className="footer-logo pt40">
                                    <a href="https://noorisys.com/" target='_blank' rel='noopener norferrer'> <img src="images/logo-dark-new-04.svg" alt="noorisys" className="img footer-logo-img" /> </a>
                                </div>
                                {/* <p className="mt15">Overall client rating is 4.9</p> */}

                                <ul className="footer_social d-flex justify-content-center mt30">
                                    <li><a href="https://twitter.com/noorisys" target="_blank"><i className="fab fa-twitter" aria-hidden="true"></i></a></li>
                                    <li> <a href="https://www.facebook.com/noorisystech" target="_blank"><i className="fab fa-facebook-f" aria-hidden="true"></i></a></li>
                                    <li><a href="https://www.youtube.com/channel/UCkBVw01AixSyVzzkQXXjX2g" target="_blank"><i className="fab fa-youtube" aria-hidden="true"></i></a></li>
                                    <li><a href="https://www.linkedin.com/company/noorisys-technologies-pvt-ltd/" target="_blank"><i className="fab fa-linkedin-in" aria-hidden="true"></i></a></li>
                                    <li> <a href="https://www.instagram.com/noorisys11/" target="_blank"><i className="fab fa-instagram" aria-hidden="true"></i></a> </li>
                                    {/* <li> <a href="https://wa.me/7796614664" target="_blank"><i className="fab fa-whatsapp" aria-hidden="true"></i></a> </li> */}
                                    {/* <li> <a href="mailto:info@noorisys.com" target="_blank"><i className="fas fa-envelope" aria-hidden="true"></i></a> </li> */}
                                </ul>

                                {/* <a href="#" className="ree-btn  ree-btn-grdt1 mw-80 no-shadows mt40">Our Brochure <i className="fas fa-arrow-right fa-btn"></i></a> */}

                            </div>
                        </div>
                        <a className="chat_btn_whatsapp" href="https://wa.me/917796614664" id="chat_btn" target="_blank" rel="noopener noreferrer" onClick={handleWhatsAppClick}><i className='fab fa-whatsapp'></i></a>
                        <button className="ree-btn  ree-btn-grdt1 no-shadows cost-btn mb-0" id="chat_btn" onClick={(e) => setOpenModal(true)}>Get A Free Quote</button>

                        <div className="col-5s">
                            <h5>For Work inquiry</h5>
                            <ul className="footer-links-list social-linkz">
                                <li><a href="tel:+442038850502"><span><i className="fas fa-phone-square"></i></span> +44 20 3885 0502 </a></li>
                                <li><a href="https://wa.me/917796614664" target="_blank" rel="noopener noreferrer"><span><i className="fab fa-whatsapp-square"></i></span> +91 77966 14664</a></li>
                                <li><a href="mailto:sales@noorisys.com"> <span><i className="fas fa-envelope"></i></span>sales@noorisys.com</a></li>
                            </ul>
                        </div>
                        <div className="col-5s">
                            <h5>Company</h5>
                            <ul className="footer-links-list">
                                <li><a href='https://noorisys.com/about' target='_blank' rel='noopener'> About us</a></li>
                                <li><a href='https://noorisys.com/portfolio' target='_blank' rel='noopener'>Portfolio</a></li>
                                <li><a href='https://noorisys.com/become-a-partner' target='_blank' rel='noopener'>Become a Partner </a></li>
                                <li><a href='https://noorisys.com/contact-us' target='_blank' rel='noopener'>Contact Us</a></li>
                                {/* <li><a>Faqs</a></li>
                                <li><a>Privacy & Policy</a></li> */}
                            </ul>
                        </div>
                        <div className="col-5s">
                            <h5>Services</h5>
                            <ul className="footer-links-list">
                                <li><a href='https://noorisys.com/website-development' target='_blank' rel='noopener'>Web Development </a></li>
                                <li><a href='https://noorisys.com/support-services' target='_blank' rel='noopener'>Customer Support </a></li>
                                <li><a href='#work'>Ready Solutions</a></li>
                                <li><a href='#technologies'>Technologies</a></li>
                            </ul>
                        </div>
                        <div className="col-5s">
                            <h5>Industries</h5>
                            <ul className="footer-links-list">
                                <li><a href='https://noorisys.com/health-care' target='_blank' rel='noopener'>Healthcare</a></li>
                                <li><a href='https://noorisys.com/ecommerce' target='_blank' rel='noopener'>eCommerce</a></li>
                                <li><a href='https://noorisys.com/tourism' target='_blank' rel='noopener'>Tourism</a></li>
                                <li><a href='https://noorisys.com/fintech' target='_blank' rel='noopener'>Fintech</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="container ft-cpy bt-top mt70">
                    <div className="row">
                        <div className="col-lg-5">
                            <div className="ft-copyright">
                                {/* <p>We are tracking any intention of piracy.</p> */}
                            </div>
                        </div>
                        <div className="col-lg-7">
                            <div className="ft-copyright ft-r">
                                <p>© 2024. All Rights Reserved By <a href="https://noorisys.com/" target="blank">Noorisys</a></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <button className='btn btn-secondary cost-btn'>Cost Calulator</button> */}
        </footer>
    )
}

export default Footer   